import { IModuleMetaData } from "./company-module";

export class ElectronischeFacturatieMetaData {
	private metadata:IModuleMetaData;

	private constructor(metadata:IModuleMetaData){
		this.metadata = metadata;
	}

	public static create(metadata:IModuleMetaData):ElectronischeFacturatieMetaData{
		return new ElectronischeFacturatieMetaData(metadata || {});
	}

	public getMaxPeppolSentsPerMonth():number{
		return parseInt(this.metadata["max-peppol-sents-per-month"] || "0") || 0;
	}

	public setMaxPeppolSentsPerMonth(count:number):ElectronischeFacturatieMetaData {
		this.metadata["max-peppol-sents-per-month"] = `${count}`;
		return this;
	}

	public getPeppolSentsThisMonth():number{
		return parseInt(this.metadata["peppol-sents-this-month"] || "0") || 0;
	}

	public setPeppolSentsThisMonth(count:number):ElectronischeFacturatieMetaData {
		this.metadata["peppol-sents-this-month"] = `${count}`;
		return this;
	}

	public getLastPeppolSentDate():Date {
		return new Date((parseInt(this.metadata["last-peppol-sent-date"]) * 1000) || 0);
	}

	public setLastPeppolSentDate(d:Date):ElectronischeFacturatieMetaData {
		this.metadata["last-peppol-sent-date"] = `${Math.round(d.getTime() / 1000)}`;
		return this;
	}

	public getUsesWinfaktPeppol():boolean {
		return this.metadata["uses-winfakt-peppol"] == "true";
	}

	public setUsesWinfaktPeppol(value:boolean) {
		this.metadata["uses-winfakt-peppol"] = `${value}`;
	}

	public static createDefault():ElectronischeFacturatieMetaData{
		let data = new ElectronischeFacturatieMetaData({});
		data.setMaxPeppolSentsPerMonth(50);
		data.setUsesWinfaktPeppol(true);
		return data;
	}
}